import type { ThemeTokens } from "@klarity/themes";
import { useEffect } from "react";

const loaded = new Set<string>();

/** FontRef.files order is regular, bold, italic, bold italic (plan 02). */
const FACES: FontFaceDescriptors[] = [
  { weight: "400", style: "normal" },
  { weight: "700", style: "normal" },
  { weight: "400", style: "italic" },
  { weight: "700", style: "italic" },
];

/** Registers uploaded theme fonts with document.fonts (same-origin URLs only, so font-src 'self' holds). */
export function useThemeFonts(tokens: ThemeTokens, fileUrl: (src: string) => string): void {
  useEffect(() => {
    if (typeof FontFace === "undefined" || !("fonts" in document)) return;
    for (const ref of [tokens.fonts.body, tokens.fonts.mono]) {
      if (ref.source !== "upload") continue;
      for (const [i, file] of (ref.files ?? []).entries()) {
        const key = `${ref.family}|${file}`;
        if (loaded.has(key)) continue;
        loaded.add(key);
        const face = new FontFace(ref.family, `url(${JSON.stringify(fileUrl(file))})`, FACES[i] ?? FACES[0]);
        face
          .load()
          .then((f) => document.fonts.add(f))
          .catch(() => loaded.delete(key));
      }
    }
  }, [tokens, fileUrl]);
}
